import { ONLINE, OFFLINE } from 'redux-queue-offline';

export const setInitialNetworkStatus = () => ({
    type: navigator.onLine ? ONLINE : OFFLINE
});
